import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RoutingConfig } from 'src/app/utils/routing-config';
import routes from '../../config/routing.json';
import { ToastUtils } from 'src/app/utils/toast_builder';
import { PopoverComponent } from 'src/app/widgets/popover/popover.component';
import { ConnectionService } from 'src/app/services/connection.service';
import { Store } from '@ngrx/store';
import { Farm } from 'src/app/models/farm/farm.model';
import { lastValueFrom, take } from 'rxjs';
import { updateFarmPrivacy } from 'src/app/utils/states-management/actions/farm.action';

@Component({
  selector: 'app-account-privacy',
  templateUrl: './account-privacy.component.html',
  styleUrls: ['./account-privacy.component.scss'],
})
export class AccountPrivacyComponent implements OnInit {

  constructor(
    public translateService: TranslateService,
    private router: Router,
    private routingConfig: RoutingConfig,
    private toastUtils: ToastUtils,
    private store: Store<{ farm: Farm }>,
    public connectionService: ConnectionService

  ) {
  }
  isOnline = true;
  privacy
  farm
  isDashboardView: boolean;
  formConfig
  async ngOnInit() {
    this.connectionService.isOnline$.subscribe(isOnline => {
      this.isOnline = isOnline;
    })
    this.formConfig = await lastValueFrom(this.routingConfig.getPageFormConfig('AccountPrivacyComponent'));
    this.isDashboardView = this.router.url.includes(routes.dashboard.home);
    this.farm = await lastValueFrom(this.store.select('farm').pipe(take(1)));
    this.privacy = this.farm?.privacy;

  }
  
  async goBack() {
    this.router.navigateByUrl(await this.routingConfig.getBackUrl());
  }
  async next() {
    if (!this.isDashboardView) {
      this.store.dispatch(updateFarmPrivacy({ privacy: this.privacy }));

      this.router.navigateByUrl(await this.routingConfig.getNextUrl());
    }
    else {
      this.showPopOver();

    }
  }

  async showPopOverInfo() {
    console.log("test")
    let componentProps = {
      key1: await this.translateService.instant('infobull.privacy_infobull'),
      close_button: await this.translateService.instant('submit'),
    };

    await this.toastUtils.popOverBuilder(
      componentProps,
      PopoverComponent,
      'popover-custom'
    );
  }

  async showPopOver(has_showed_popover = true) {
    let componentProps = {
      key1: await this.translateService.instant('info_bull_privacy'),
      close_button: await this.translateService.instant('submit'),
    };
    const popover = await this.toastUtils.popOverBuilder(
      componentProps,
      PopoverComponent,
      'popover-custom'
    );
    const { data } = await popover.onDidDismiss();
    if (data) {
      this.store.dispatch(updateFarmPrivacy({ privacy: this.privacy }));
    }

    // this.has_showed_popover = has_showed_popover;
  }
}
